// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import config from '../../config/config';

// Growth Plan Documents API (DocumentType is always 4 on backend side)
export const growthPlanDocumentAPI = createApi({
  reducerPath: 'growthPlanDocumentAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ['growthPlanDocs'],
  endpoints: (builder) => ({
    // List documents for a specific goal (growth plan)
    getGrowthPlanDocsList: builder.query<any, any>({
      query: ({ affiliateCode, aboNumber, goalId }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/actionplans/type/goal/${goalId}`,
        method: 'GET',
      }),
      providesTags: ['growthPlanDocs'],
    }),

    // Upload document to a goal (multipart/form-data FormData payload)
    uploadGrowthPlanDoc: builder.mutation<any, any>({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/actionplan/create/type/goal`,
        method: 'POST',
        data: payload,
      }),
      invalidatesTags: ['growthPlanDocs'],
    }),

    // Delete a document by action plan id
    deleteGrowthPlanDoc: builder.mutation<any, any>({
      query: ({ id }) => ({
        url: `/am/abo/actionplan/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['growthPlanDocs'],
    }),
  }),
});

export const {
  useGetGrowthPlanDocsListQuery,
  useUploadGrowthPlanDocMutation,
  useDeleteGrowthPlanDocMutation,
} = growthPlanDocumentAPI;
